const _temp0 = require("../PlanTunnelChoose.vue");
const _temp1 = require("../PlanTunnelEnterprise.vue");
const _temp2 = require("../PlanTunnelHoursTooltip.vue");
const _temp3 = require("../PlanTunnelPlan.vue");
const _temp4 = require("../PlanTunnelProceed.vue");
const _temp5 = require("../PlanTunnelThankYou.vue");
const _temp6 = require("../ProductCardPriceDiscount.vue");
module.exports = {
  "PlanTunnelChoose": _temp0,
  "PlanTunnelEnterprise": _temp1,
  "PlanTunnelHoursTooltip": _temp2,
  "PlanTunnelPlan": _temp3,
  "PlanTunnelProceed": _temp4,
  "PlanTunnelThankYou": _temp5,
  "ProductCardPriceDiscount": _temp6
}